<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-header">
        <i class="fa fa-envelope"></i> Messages
      </div>
      <div class="card-body">
        <div class="mb-3">
          <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()">
            <i class="fa fa-plus"></i> Add Message
          </button>
        </div>
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Title</th>
              <th>State</th>
              <th>Rewards</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading) {
              <tr>
                <td colspan="6" class="text-center">
                  <span class="spinner-border spinner-border-sm"></span> Loading...
                </td>
              </tr>
            } @else if (messages.length === 0) {
              <tr>
                <td colspan="6" class="text-center text-muted">No messages found.</td>
              </tr>
            } @else {
              @for (message of messages; track message.newsId; let i = $index) {
                <tr>
                  <td>{{ (pageNumber - 1) * resultsPerPage + i + 1 }}</td>
                  <td>{{ message.newsId }}</td>
                  <td>{{ getDisplayTitle(message) }}</td>
                  <td>
                    @if (!message.state?.isRead) {
                      <span class="badge bg-warning me-1">Unread</span>
                    } @else {
                      <span class="badge bg-success me-1">Read</span>
                    }
                    @if (message.state?.isRewardGranted) {
                      <span class="badge bg-info">Reward Granted</span>
                    }
                    @if (message.isRate) {
                      <span class="badge bg-primary">Rate</span>
                    }
                  </td>
                  <td>
                    @if (message.rewards.length === 0) {
                      <span class="text-muted">—</span>
                    } @else {
                      @for (reward of message.rewards; track reward.rewardId) {
                        <span class="badge bg-secondary me-1">
                          {{ getCurrencyTypeName(reward.currencyType) }} × {{ reward.currencyQuantity }}
                          @if (reward.currencyTicketCost > 0) {
                            <span class="ms-1">({{ reward.currencyTicketCost }} tickets)</span>
                          }
                        </span>
                      }
                    }
                  </td>
                  <td>
                    <button class="btn btn-sm btn-info me-1" type="button" (click)="onClickRewards(message)" tooltip="Rewards" placement="top">
                      <i class="fa fa-gift"></i>
                    </button>
                    <button class="btn btn-sm btn-warning me-1" type="button" (click)="onClickEdit(message)" tooltip="Edit" placement="top">
                      <i class="fa fa-edit"></i>
                    </button>
                    <span class="text-muted mx-1">|</span>
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(message)" tooltip="Delete" placement="top">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
        <br/>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-muted">
            Showing {{ (pageNumber - 1) * resultsPerPage + 1 }} to {{ (pageNumber - 1) * resultsPerPage + messages.length }} of {{ totalResults }} entries
          </small>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="pageNumber <= 1">
              <button class="page-link" (click)="onClickPaginationPrevious()" [disabled]="pageNumber <= 1">&laquo;</button>
            </li>
            @for (page of getPageNumbers(); track $index) {
              @if (page === null) {
                <li class="page-item disabled"><span class="page-link">...</span></li>
              } @else {
                <li class="page-item" [class.active]="page === pageNumber">
                  <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
                </li>
              }
            }
            <li class="page-item" [class.disabled]="pageNumber >= totalPages">
              <button class="page-link" (click)="onClickPaginationNext()" [disabled]="pageNumber >= totalPages">&raquo;</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<app-news-user-add-modal #addModal></app-news-user-add-modal>
<app-news-user-edit-modal #editModal></app-news-user-edit-modal>
<app-news-rewards-modal #rewardsModal></app-news-rewards-modal>
